export var zIndex = {
    floatingButtons: 50,
    modals: 100,
    dropDowns: 200,
    tooltips: 300,
    notifications: 400,
};
//# sourceMappingURL=zIndex.js.map